"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENSIENT_NOMINAL_MIX_RATIO = exports.SENSIENT_1500_ML_BIB_RANGE = void 0;
const volume_1 = require("../../../../../../unit/volume");
const mix_ratio_1 = require("../enhancement/mix-ratio");
/**
 * Range properties for 1.5 Liter bag-in-box enhancements supplied by Sensient
 */
exports.SENSIENT_1500_ML_BIB_RANGE = {
    depletable: true,
    expendable: false,
    rangeExhaust: volume_1.Liter.make({ amount: 0 }),
    rangeTrigger: volume_1.Liter.make({ amount: 0.3 }),
    rangeFullCapacity: volume_1.Liter.make({ amount: 1.5 }),
};
/**
 * See {@link NominalMixRatio}
 */
exports.SENSIENT_NOMINAL_MIX_RATIO = mix_ratio_1.NominalMixRatio.make(100);
//# sourceMappingURL=common.js.map